import React from 'react';
import styles from './Facilities.module.css';

export const TimeSlot = ({ time, isSelected, onClick }) => (
  <button 
    className={`${styles.timeButton} ${isSelected ? styles.activeTag : ''}`}
    onClick={onClick}
  >
    {time}
  </button>
);